// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7490d4d6] *{font-family:\"Lato\",sans-serif !important}", ""]);
// Exports
module.exports = exports;
